// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgEssentials: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M1.25 5.25a4 4 0 0 1 4-4h13.5a4 4 0 0 1 4 4v11a4 4 0 0 1-4 4H15.5l-3.146 3.146a.5.5 0 0 1-.708 0L8.5 20.25H5.25a4 4 0 0 1-4-4zm8.827 4.111c.399.391.876.647 1.427.763.323.069.973.048 1.303-.041a2.902 2.902 0 0 0 2.017-2.03c.1-.36.098-1.09-.003-1.447a2.881 2.881 0 0 0-1.489-1.81 2.5 2.5 0 0 0-1.265-.296c-.502 0-.811.072-1.266.297-1.748.863-2.119 3.195-.724 4.564m7.501 6.016a.617.617 0 0 0 .05-.244c0-.823-.455-1.664-1.237-2.355-1.05-.927-2.688-1.593-4.327-1.592-1.64.001-3.277.666-4.326 1.592-.782.692-1.238 1.532-1.238 2.355l.049.24.159.386c.247.6.832.991 1.481.991h7.75c.65 0 1.234-.391 1.482-.991z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgEssentials);
export default Memo;
